
import { Map, useMap } from '@vis.gl/react-google-maps';
import { Poi } from './types';
import { ClusteredTreeMarkers } from './ClusteredMarkerAdboard';
import { useEffect } from 'react';

export default function AdboardMap({
  pois,
  id,
  // highlightedKeys
}:{
    id?: string,
    pois: Poi[],
    highlightedKeys?:string[]
}) {

  const map = useMap();
  
  useEffect(()=>{
    // Adjust map bounds to fit all markers
    if (pois.length && typeof google.maps.LatLngBounds == 'function') {
      const bounds = new google.maps.LatLngBounds();
      for(const poi of pois) {
        bounds.extend(poi.location);
      }
      map?.fitBounds(bounds);
    }
  },[pois,map])

  return (
    <Map
      fullscreenControl
      zoomControl
      scaleControl
      mapTypeControl
      streetViewControl
      rotateControl
      defaultZoom={20}
      mapId={id||'DEMO_MAP_ID'}
      defaultCenter={ pois[0]?.location }
      gestureHandling={'greedy'}
      disableDefaultUI
    >
      <ClusteredTreeMarkers trees={pois} />
    </Map>
  )
}
